import { OUTCOMES, type OutcomeKind } from '@/shared/domain'
import { OUTCOME_LABEL } from '@/shared/pipelineColors'

// Keys older code wrote to the timeline under a name today's OUTCOMES no
// longer uses. Aliased straight to the current Swedish label rather than
// guessed from the string, so a retired key reads exactly like whatever
// replaced it. Add to this list as other legacy spellings turn up.
const LEGACY_OUTCOME_LABEL: Record<string, string> = {
  reached: 'Kontakt',
  voicemail: 'Inget svar',
  no_answer: 'Inget svar',
  asked_to_call_back: 'Bad om återuppringning',
  gatekeeper: 'Grindvakt',
  not_interested: 'Inte intresserad',
  wrong_number: 'Fel nummer',
  hung_up: 'La på',
}

// Swedish label for a call outcome key, shown in the feed's outcome Badge.
// OUTCOMES carries the precise label for every outcome the composer can log
// today; OUTCOME_LABEL's coarser bucket covers the values the admin
// analytics use; LEGACY_OUTCOME_LABEL covers retired keys still sitting on
// old entries. A key in none of the three is shown with a generic label.
export function outcomeLabel(outcome?: string): string {
  if (!outcome) return ''
  return OUTCOMES[outcome as OutcomeKind]?.label
    ?? OUTCOME_LABEL[outcome as keyof typeof OUTCOME_LABEL]
    ?? LEGACY_OUTCOME_LABEL[outcome]
    ?? 'Okänt utfall'
}
